import config from "../config";
import { sendPostRequest, sendPutRequest } from "../Utility/FetchUtils";

export default class ApplicationUpdateApi {
  static BASE_URL = config.SERVICE_URL + "/ApplicationUpdate";

  static checkUpdate() {
    const url = `${this.BASE_URL}/check-update`;
    return sendPostRequest(url);
  }

  static setAutomaticCheckUpdate(isAutomaticCheckUpdate: boolean) {
    const url = `${this.BASE_URL}/automatic-check-update/${isAutomaticCheckUpdate}`;
    return sendPutRequest(url);
  }
}